import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getSpaceMembersApi } from "~/Redux/SpaceMembers";
import { useFetchData } from "~/sharedComponents/hooks/useFetchData";
import { getLocationSpaceId } from "../state/selectors";

export const useSpaceMembers = () => {
    const spaceId = useSelector(getLocationSpaceId);
    const [spaceResponse, isSpaceDataLoaded] = useFetchData(() => getSpaceMembersApi(spaceId));

    const space = spaceResponse?.data?.byId;
    const spaceUserIds = useMemo(() => space?.members.map(x => x.userId), [space?.members]);

    return { canInviteUsers: space?.canInviteUsers, spaceUserIds, isSpaceDataLoaded };
};
